import { Component, input, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  imports: [],
  templateUrl: './redirect.html',
  styleUrl: './redirect.css',
})
export class Redirect implements AfterViewInit {
  readonly message = input.required<string>();
  readonly url = input.required<string>();

  ngAfterViewInit(): void {
    setTimeout(() => {
      document.location.href = this.url();
    }, 1000);
  }
}
